var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hr',{staticClass:"mb-5 mt-6 styles"})
}
var staticRenderFns = []

export { render, staticRenderFns }